import Vue from "vue";
import VueRouter from "vue-router";
import Form from "@/components/Form.vue";
import store from "./store.js";

Vue.use(VueRouter);

const routes = [{
        path: "/",
        redirect: "/webportal",
    },
    {
        path: "/webportal/",
        redirect: "/webportal/hongkong",
        component: Form,
        children: [{
                path: "hongkong",
                pathToRegexpOptions: { strict: true },
                beforeEnter(to, from, next) {
                    store.state.country = "hk";
                    next();
                },
            },
            {
                path: "hongkong/",
                pathToRegexpOptions: { strict: true },
                redirect:"/webportal/hongkong"
            },
            {
                path: "singapore",
                pathToRegexpOptions: { strict: true },
                beforeEnter(to, from, next) {
                    store.state.country = "sg";
                    next();
                },
            },
            {
                path: "singapore/",
                pathToRegexpOptions: { strict: true },
                redirect:"/webportal/singapore"
            },
            {
                path: "thailand",
                pathToRegexpOptions: { strict: true },
                beforeEnter(to, from, next) {
                    store.state.country = "th";
                    next();
                },
            },
            {
                path: "thailand/",
                pathToRegexpOptions: { strict: true },
                redirect:"/webportal/thailand"
            },
        ],
    },
    {
        path: "*",
        redirect: "/",
    },
];

export default new VueRouter({
    routes: routes,
    mode: "history",
});
